import { render, staticRenderFns } from "./CheckoutPedidoPix.vue?vue&type=template&id=2083e3a4&scoped=true"
import script from "./CheckoutPedidoPix.vue?vue&type=script&lang=js"
export * from "./CheckoutPedidoPix.vue?vue&type=script&lang=js"
import style0 from "./CheckoutPedidoPix.vue?vue&type=style&index=0&id=2083e3a4&prod&scoped=true&lang=css"
import style1 from "./CheckoutPedidoPix.vue?vue&type=style&index=1&id=2083e3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2083e3a4",
  null
  
)

export default component.exports